import {
    ModelBase,
    HouseType,
    HomePage,
    UserCenter,
    DecorationDesign,
    RetrievePassword,
    LoginPages,
    LandingPage,
    RenderingVoucher,
    PricingPage,
    DwgToPdf,
} from '@/pages';

const ROUTE_LIST = [
    { path: '/home', component: HomePage },
    { path: '/model-base', component: ModelBase },
    { path: '/house-type', component: HouseType },
    { path: '/user-center', component: UserCenter },
    {
        path: '/decoration-design',
        component: DecorationDesign,
    },
    {
        path: '/retrieve-password',
        component: RetrievePassword,
    },
    {
        path: '/login',
        component: LoginPages,
    },
    { path: '/landing', component: LandingPage },
    { path: '/rendering-voucher', component: RenderingVoucher },
    { path: '/pricing-page', component: PricingPage },
    { path: '/dwg-to-pdf', component: DwgToPdf },
];
export default ROUTE_LIST;
